
import { Vue, Component } from 'vue-property-decorator'
import Subelement from '@/types/subelement'
import Element from '@/types/element'
import Column from '@/types/column'
import axios from 'axios'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: {}
})

export default class SubelementEditElementsTab extends Vue {
  settings = {
    routeNames: { list: 'subelements', show: 'subelementShow', edit: 'subelementEdit' },
    routeParamKey: 'subelementId',
    functionNames: { setCurrent: 'setCurrentSubelement', save: 'saveSubelement' },
    getterNames: { current: 'currentSubelement', loading: 'loadingSubelement', errors: 'subelementErrors' }
  }

  columns:Column[] = [
    {
      title: 'Naam',
      key: 'name',
      dataIndex: 'name',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Commerciële naam',
      key: 'name_sales',
      dataIndex: 'name_sales',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Actie\'s',
      key: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ]

  element = null
  showAddModal = false
  searchTimer = 0
  elements:Element[] = []

  showAddElementModal () : void {
    this.showAddModal = true
  }

  hideAddElementModal () : void {
    this.showAddModal = false
    this.element = null
  }

  getElementDetails (id:number) : void {
    axios.get(process.env.VUE_APP_API_URL + '/elements/' + id).then((res) => {
      this.element = res.data.data
    })
  }

  addElement () : void {
    this.$store.dispatch('elementAddedToSubelement', this.element)
    this.hideAddElementModal()
  }

  deleteElement (id:number) : void {
    this.$store.dispatch('elementDeletedFromSubelement', id)
  }

  searchElement (val:string) : void {
    if (val.length >= 3) {
      clearTimeout(this.searchTimer)

      this.searchTimer = setTimeout(() => {
        axios.get(process.env.VUE_APP_API_URL + '/elements?filter[search]=' + val).then((res) => {
          this.elements = res.data.data
        })
      }, 500)
    }
  }

  onRowClick (rowData:{id:number}) : { on: { click: () => void }} {
    return {
      on: {
        click: () => {
          const keyboard = window.event as KeyboardEvent
          if (can('elements.edit')) {
            const route = this.$router.resolve({ name: 'elementEdit', params: { elementId: rowData.id.toString() } })
            window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
          } else if (can('elements.view')) {
            const route = this.$router.resolve({ name: 'elementShow', params: { elementId: rowData.id.toString() } })
            window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
          }
        }
      }
    }
  }

  get currentItem () : Subelement {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
